import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {VerifyMailService} from '../../../../shared/services/verify-mail.service';
import {AuthService} from '../../../../shared/services/auth.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Subscription} from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-active-mail',
  templateUrl: './activateMail.component.html'
})
export class ActivateMailComponent implements OnInit, OnDestroy {
  token: {};
  verified = false;
  subscription: Subscription;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private verifyMailServic: VerifyMailService,
    private auth: AuthService,
    private snackBar: MatSnackBar,
    private translate: TranslateService,
  ) {}

  async ngOnInit() {
    this.subscription = this.route.params.subscribe(param => {
      this.token = param;
    });
    if (!this.auth.isAuthenticated()) {
      this.router.navigate(['login'], {
        queryParams: { returnUrl: this.route.snapshot['_routerState'].url }
      });
      return;
    }

    try {
      await this.verifyMailServic.setParams(this.token);
      status = await this.verifyMailServic.make();
      this.snackBar.open(this.translate.instant('Sellers.Products.EmailVerifiedSuccessfully'), null, {
        duration: 3000
      });
      this.router.navigate(['/']);
    } catch (err) {
      this.verified = false;
      this.snackBar.open(this.translate.instant('Sellers.Products.VerificationTokenExpired'), null, {
        duration: 3000
      });
    }
  }

  ngOnDestroy() {
    if (this.subscription) {
  this.subscription.unsubscribe();
}
  }
}
